import { ManagementComponent } from '../management.component';
import { Component, OnInit, Inject } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { TranslateService } from '@ngx-translate/core';
import {Router} from "@angular/router";
import { MatRadioChange } from '@angular/material/radio';
import { MatBottomSheet, MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {MatSliderModule} from '@angular/material/slider';
import { ManagementServiceService } from 'src/app/management-service.service';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

@Component({
  selector: 'app-configurations',
  templateUrl: './configurations.component.html',
  styleUrls: ['./configurations.component.css']
})
export class ConfigurationsComponent implements OnInit {

  constructor(public parent: ManagementComponent, private managementService:ManagementServiceService, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private router:Router, private _bottomSheet: MatBottomSheet) {
    translate.addLangs(['en', 'ro', 'de', 'es', 'fr', 'it', 'pl', 'pt']);
    translate.setDefaultLang('en');

    const browserLang = this.parent.getLanguage();
    translate.use(browserLang.match(/en|ro|de|es|fr|it|pl|pt/) ? browserLang : 'en');

     // Debounce search.
     this.configSearchTermUpdate.pipe(
      debounceTime(500),
      distinctUntilChanged())
      .subscribe(value => {

        if(value?.length >= 1){
          this.ConfigurationTerm = value;
          this.GetImportConfigurations();
        }
      });

      // Debounce search.
     this.addressSearchTermUpdate.pipe(
      debounceTime(200),
      distinctUntilChanged())
      .subscribe(value => {
        if(value?.length >= 1){
          this.GetAddressesFiltered();
        }
      });

      // Debounce search.
     this.partnerSearchTermUpdate.pipe(
      debounceTime(200),
      distinctUntilChanged())
      .subscribe(value => {
        if(value?.length >= 1){
          this.PartnersFilter.SearchTerm = value;
          this.GetPartnersFiltered();
        }
      });

     // Debounce search.
     this.brandSearchTermUpdate.pipe(
      debounceTime(200),
      distinctUntilChanged())
      .subscribe(value => {
        if(value?.length >= 1){
          this.GetBrandsFiltered(value);
        }
      });

      // Debounce search.
     this.warehouseSearchTermUpdate.pipe(
      debounceTime(200),
      distinctUntilChanged())
      .subscribe(value => {
        if(value?.length >= 1){
          this.GetWarehousesFiltered(value);
        }
      });
   }

   configSearchTermUpdate = new Subject<string>();
   partnerSearchTermUpdate = new Subject<string>();
   PartnersFilter: {[k: string]: any} = {};
   Partners:any[];

   AddressesFilter: {[k: string]: any} = {};
   Addresses:any[];
   addressSearchTermUpdate = new Subject<string>();

   BrandFilter: {[k: string]: any} = {};
   Brands:any[];
   Brand:any;
   brandSearchTermUpdate = new Subject<string>();
   NewBrand: {[k: string]: any} = {};

   WarehouseFilter: {[k: string]: any} = {};
   Warehouses:any[];
   Warehouse:any;
   warehouseSearchTermUpdate = new Subject<string>();
   NewWarehouse: {[k: string]: any} = {};

   WHZones:any[];
   NewWHZone: {[k: string]: any} = {};
   BrandExceptionTypes:any[];
   BrandExceptions:any[];
   NewBrandException: {[k: string]: any} = {};
   ShowAddNewBrandException:boolean = false;
   ShowDeleteBrandExceptionQuestion:boolean = false;
   BrandB2BSettings: {[k: string]: any} = null;

  selectedBrand: File = null;
  newBrandLogo:FormGroup;
  selectedFile: File = null;

  ShowDeleteLogoQuestion:boolean;
  ShowDeleteBrandQuestion:boolean;

  ShowProfitsContainer:boolean = false;

  LeadTimeTypes:any[];
  LeadTimePriorityStrategies:any[];
  ShowChangeLeadTimeStrategyPopup:boolean = false;
  SelectedLeadTimePriorityStrategy:any = null;

  // Dropdown states for modern UI
  discountGroupDropdownOpen: boolean = false;
  percentageImpactDropdownOpen: boolean = false;
  newWarehouseAddressDropdownOpen: boolean = false;
  exceptionTypeDropdownOpen: boolean = false;
  leadTimeStrategyDropdownOpen: boolean = false;
  warehouseAddressDropdownOpen: boolean = false;
  leadTimeTypeDropdownOpen: boolean = false;

  // Search focus states for modern UI
  brandSearchFocused: boolean = false;
  warehouseSearchFocused: boolean = false;

  // Tab navigation state
  selectedTab: number = 0;

  ngOnInit(): void {
    this.InitializeBrandFilter();
    this.InitializePartnersFilter();
    this.InitializeWarehouseFilter();
    this.InitializeAddressesFilter();
    this.GetMasterData();
    this.GetSharedMasterData();

    this.GetBrandsFiltered("", 1);

    this.newBrandLogo = new FormGroup({
      Name: new FormControl(null),
      UploadedFile: new FormControl(null)
    });
  }

  InitializePartnersFilter(){
    this.PartnersFilter = {};
    this.PartnersFilter.SearchTerm = "";

    this.PartnersFilter.Pager = {};
    this.PartnersFilter.Pager.PageIndex = 1;
    this.PartnersFilter.Pager.PageSize = 50;
    this.PartnersFilter.Pager.TotalCount = 0;

    this.PartnersFilter.Company = {};
    this.PartnersFilter.Company = null;
    
    this.PartnersFilter.Country = {};
    this.PartnersFilter.Country = null;
  }

  InitializeBrandFilter(){
    this.BrandFilter = {};
    this.BrandFilter.SearchTerm = "";
    this.BrandFilter.Pager = {};
    this.BrandFilter.Pager.PageIndex = 1;
    this.BrandFilter.Pager.PageSize = 50;
    this.BrandFilter.Pager.TotalCount = 0;
  }

  InitializeAddressesFilter(){
    this.AddressesFilter = {};
    this.AddressesFilter.Product = "";
    this.AddressesFilter.Pager = {};
    this.AddressesFilter.Pager.PageIndex = 1;
    this.AddressesFilter.Pager.PageSize = 50;
    this.AddressesFilter.Pager.TotalCount = 0;
  }

  InitializeWarehouseFilter(){
    this.WarehouseFilter = {};
    this.WarehouseFilter.SearchTerm = "";
    this.WarehouseFilter.Pager = {};
    this.WarehouseFilter.Pager.PageIndex = 1;
    this.WarehouseFilter.Pager.PageSize = 50;
    this.WarehouseFilter.Pager.TotalCount = 0;
  }

  GetMasterData(){
    var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage()
   };
 
  this.parent.loading = true;
 
  this.managementService.GetIndustryProductsMasterData(request).subscribe(response => {

    if(response["Status"] != 1){
     this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.LeadTimeTypes = response["LeadTimeTypes"];
      this.LeadTimePriorityStrategies = response["LeadTimePriorityStrategies"];
    }

    this.parent.loading = false;
   });
   }

   ProfitSettingsPercentageImpacts:any[];

   GetSharedMasterData(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    this.parent.loading = true;

    this.service.GetMasterData(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.ProfitSettingsPercentageImpacts = response["ProfitSettingsPercentageImpacts"];
        this.BrandExceptionTypes = response["BrandExceptionTypes"];
      }
   
      this.parent.loading = false;
    });
  }

  tabClick(tab) {
    if(tab.index == 0){
      this.Warehouse = null;
      this.Warehouses = [];

      this.GetBrandsFiltered("", 1);
    }
    else if(tab.index == 1){
      this.Brand = null;
      this.Brands = [];

      this.GetWarehousesFiltered("", 1);
    }
    else if(tab.index == 2){
      this.GetPartnerProfitSettings();
    }
  }

  onTabChange(tabIndex: number) {
    this.selectedTab = tabIndex;
    if(tabIndex == 0){
      this.Warehouse = null;
      this.Warehouses = [];
      this.GetBrandsFiltered("", 1);
    }
    else if(tabIndex == 1){
      this.Brand = null;
      this.Brands = [];
      this.GetWarehousesFiltered("", 1);
    }
    else if(tabIndex == 2){
      this.GetPartnerProfitSettings();
    }
  }

  GetBrandExceptions(){
    if(this.Brand == null || this.Brand.ID == null){
      return;
    }

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      BrandID:this.Brand.ID
    };

    this.parent.loading = true;

    this.service.GetBrandExceptions(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.BrandExceptions = response["BrandExceptions"];
        this.BrandB2BSettings = response["BrandB2BSettings"];
        // Initialize the form for adding new exceptions
        this.CancelEditBrandException();
      }

      this.parent.loading = false;
    });
  }

  UpdateBrandB2BSettings(){
    if(this.BrandB2BSettings == null){
      return;
    }

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      BrandB2BSettings:this.BrandB2BSettings
    };

    this.parent.loading = true;

    this.service.AddUpdateBrandB2BSettings(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar("Success", "OK", "light-info-snackbar");
        this.BrandB2BSettings = response["BrandB2BSettings"];
      }

      this.parent.loading = false;
    });
  }

  OpenAddNewBrandException(){
    this.ShowAddNewBrandException = true;
    this.NewBrandException = {
      ID: 0,
      BrandID: this.Brand.ID,
      Type: null,
      UIMessage: "",
      NameInterdictions: "",
      PartNumberInterdictions: ""
    };
  }

  EditBrandExceptionModal(exception:any){
    this.ShowAddNewBrandException = true;
    this.NewBrandException = JSON.parse(JSON.stringify(exception));
  }

  CancelEditBrandException(){
    this.NewBrandException = {
      ID: 0,
      BrandID: this.Brand.ID,
      Type: null,
      UIMessage: "",
      NameInterdictions: "",
      PartNumberInterdictions: ""
    };
  }

  AddUpdateBrandException(){
    // Validation based on exception type
    if(this.NewBrandException.Type == null){
      this.parent.openSnackBar("Please select an exception type", "OK", "alert-info-snackbar");
      return;
    }

    // Validate UIMessage for Type.ID == 0
    if(this.NewBrandException.Type.ID == 0){
      if(this.NewBrandException.UIMessage == null || this.NewBrandException.UIMessage.trim() == ""){
        this.parent.openSnackBar("Please fill UI Message", "OK", "alert-info-snackbar");
        return;
      }
    }

    // Validate NameInterdictions and PartNumberInterdictions for Type.ID == 1
    if(this.NewBrandException.Type.ID == 1){
      if((this.NewBrandException.NameInterdictions == null || this.NewBrandException.NameInterdictions.trim() == "") &&
         (this.NewBrandException.PartNumberInterdictions == null || this.NewBrandException.PartNumberInterdictions.trim() == "")){
        this.parent.openSnackBar("Please fill at least one interdiction field (Name or Part Number)", "OK", "alert-info-snackbar");
        return;
      }
    }

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      BrandException:this.NewBrandException
    };

    this.parent.loading = true;

    this.service.AddUpdateBrandException(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar("Success", "OK", "light-info-snackbar");

        var updatedException = response["BrandException"];

        if(this.NewBrandException.ID == 0){
          // Add new exception to list
          if(this.BrandExceptions == null){
            this.BrandExceptions = [];
          }
          this.BrandExceptions.push(updatedException);
        }
        else{
          // Update existing exception in list
          const index = this.BrandExceptions.findIndex(x => x.ID === updatedException.ID);
          if (index !== -1) {
            this.BrandExceptions[index] = updatedException;
          }
        }

        // Reset form and close modal
        this.ShowAddNewBrandException = false;
        this.CancelEditBrandException();
      }

      this.parent.loading = false;
    });
  }

  PrepareDeleteBrandException(exception:any){
    this.NewBrandException = JSON.parse(JSON.stringify(exception));
    this.ShowDeleteBrandExceptionQuestion = true;
  }

  DeleteBrandException(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ID:this.NewBrandException.ID
    };

    this.parent.loading = true;

    this.service.DeleteBrandException(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar("Success", "OK", "light-info-snackbar");
        this.BrandExceptions = this.BrandExceptions.filter(x => x.ID != this.NewBrandException.ID);
        this.NewBrandException = {};
      }

      this.ShowDeleteBrandExceptionQuestion = false;
      this.parent.loading = false;
    });
  }

  OpenChangeLeadTimeStrategyPopup(){
    if(this.Brand == null){
      this.parent.openSnackBar("Please select a brand first", "OK", "alert-info-snackbar");
      return;
    }

    // Set default strategy to ConfigProductOffer (ID = 6)
    this.SelectedLeadTimePriorityStrategy = this.LeadTimePriorityStrategies?.find(x => x.ID == 6);
    this.ShowChangeLeadTimeStrategyPopup = true;
  }

  UpdateBrandLeadTimeStrategy(){
    if(this.SelectedLeadTimePriorityStrategy == null){
      this.parent.openSnackBar("Please select a lead time strategy", "OK", "alert-info-snackbar");
      return;
    }

    var request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      BrandID: this.Brand.ID,
      LeadTimePriorityStrategyID: this.SelectedLeadTimePriorityStrategy.ID
    };

    this.parent.loading = true;

    this.managementService.UpdateImportConfigurationLeadTimePriorityStrategyByBrandID(request).subscribe(response => {
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
        this.ShowChangeLeadTimeStrategyPopup = false;
        this.SelectedLeadTimePriorityStrategy = null;
      }

      this.parent.loading = false;
    });
  }

  InitializePartners(){
    if(this.Partners == null || this.Partners.length == 0){
      this.GetPartnersFiltered();
    }
  }

  InitializeAddresses(){
    if(this.Addresses == null || this.Addresses.length == 0){
      this.GetAddressesFiltered();
    }
  }

  InitializeBrands(){
    if(this.Brands == null || this.Brands.length == 0){
      this.GetBrandsFiltered("", 1);
    }
  }

  InitializeWarehouses(){
    if(this.Warehouses == null || this.Warehouses.length == 0){
      this.GetWarehousesFiltered("", 1);
    }
  }

  GetBrandsFiltered(searchTerm:string, page = 1){

    this.BrandFilter.Pager.PageIndex = page;
    this.BrandFilter.SearchTerm = searchTerm;

      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        Filter:this.BrandFilter
      };

      this.managementService.GetBrandsFiltered(request).subscribe(response => {

        if(response["Status"] != 1){
         this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
         this.Brands = response["Brands"];

         if(this.Brands.length == 1){
          this.Brand = JSON.parse(JSON.stringify(this.Brands[0]));
          this.Brands = [];
          this.BrandFilter.SearchTerm = "";
          this.GetBrandExceptions();
         }
        }
       });
   }

   GetWarehousesFiltered(searchTerm:string, page = 1){
    
    this.WarehouseFilter.Pager.PageIndex = page;
    this.WarehouseFilter.SearchTerm = searchTerm;
   
      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        Filter:this.WarehouseFilter
      };

      this.service.GetWarehousesFiltered(request).subscribe(response => {
 
        if(response["Status"] != 1){
         this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
         this.Warehouses = response["Warehouses"];
    
         if(this.Warehouses.length == 1){
          this.Warehouse = JSON.parse(JSON.stringify(this.Warehouses[0]));
          this.Warehouses = [];
          this.WarehouseFilter.SearchTerm = "";
         }
        }
       });
   }

   GetAddressesFiltered(){
   
      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        Filter:this.AddressesFilter
      };

      this.service.GetAddressesFiltered(request).subscribe(response => {
 
        if(response["Status"] != 1){
         this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
         this.Addresses = response["Addresses"];
    
         if(this.Addresses.length == 1){
          this.Addresses = JSON.parse(JSON.stringify(this.Addresses[0]));
          this.Addresses = [];
          this.AddressesFilter.Product = "";
         }
        }
       });
   }

   ClearSearchBrand(){
    this.BrandFilter.SearchTerm = "";
    this.Brand = null;
    this.Brands = [];
   }

   ClearSearchBrandProfitSettings(){
    this.ProfitSettings.Brand = null;
    this.BrandSearchTerm = "";
   }

   ClearSearchWarehouse(){
    this.WarehouseFilter.SearchTerm = "";
    this.Warehouse = null;
    this.Warehouses = [];
   }

   onSelectFile(fileInput: any) {
    this.selectedFile = <File>fileInput.target.files[0];
  }

   AddUpdateBrandLogo(){
    
    const request = new FormData();
    request.append('User.Id', JSON.stringify(this.parent.User.Id));
    request.append('Language', this.parent.getLanguage());
    request.append('BrandID', this.Brand?.ID);
    request.append('UploadedFile', this.selectedFile);

    this.parent.loading = true;

    this.managementService.AddUpdateBrandLogo(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar("Success", "OK", "light-info-snackbar");
        this.Brand.LogoPath = response["LogoPath"];
      }
     
      this.parent.loading = false;
    });
  }

  DeleteBrandLogo(){
    
    const request = new FormData();
    request.append('User.Id', JSON.stringify(this.parent.User.Id));
    request.append('Language', this.parent.getLanguage());
    request.append('BrandID', this.Brand?.ID);
    request.append('UploadedFile', this.selectedFile);

    this.parent.loading = true;

    this.managementService.DeleteBrandLogo(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar("Success", "OK", "light-info-snackbar");
        this.Brand.LogoPath = null;
      }
     
      this.parent.loading = false;
    });
  }
  
  DeleteBrand(){
    
      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        BrandID:this.Brand.ID
      };

      this.service.DeleteBrand(request).subscribe(response => {
 
        if(response["Status"] != 1){
         this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
         this.Brands = [];
         this.Brand = null;
        }
       });
   }

   AddUpdateBrand(brand:any){
    
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Brand:brand
    };

    this.parent.loading = true;

    this.service.AddUpdateBrand(request).subscribe(response => {

      if(response["Status"] != 1){
       this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
        this.Brand = response["Brand"];
        this.NewBrand = {};
      }

      this.parent.loading = false;
      this.showAddNewBrand = false;

     });
 }

 showAddNewBrand:boolean;
 showAddNewWarehouse:boolean;
 ShowDeleteWarehouseQuestion:boolean;
 showAddNewWHZone:boolean;
 ShowDeleteWHZoneQuestion:boolean;

 OpenAddNewBrand(){
  this.showAddNewBrand = true;
  this.NewBrand.Name = "";
  this.NewBrand.Alternative = "";
 }

 OpenAddNewWarehouse(){
  this.showAddNewWarehouse = true;
  this.NewWarehouse.Name = "";
  this.NewWarehouse.Address = null;
  this.NewWarehouse.Company = this.parent.Company;
 }

 OpenAddNewWHZone(){
  this.showAddNewWHZone = true;
  this.NewWHZone.ID = 0;
  this.NewWHZone.Name = "";
  this.NewWHZone.Description = null;
  this.NewWHZone.ParentWarehouseID = this.Warehouse.ID;
 }

 GetWarehouse(id:number){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    WarehouseID:id
  };

  this.service.GetWarehouse(request).subscribe(response => {

    if(response["Status"] != 1){
     this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
     this.Warehouse =  response["Warehouse"];
     this.GetWHZones(this.Warehouse.ID);
    }
   });
 }

 GetWHZones(id:number){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    WarehouseID:id
  };

  this.parent.loading = true;

  this.service.GetWHZones(request).subscribe(response => {

    if(response["Status"] != 1){
     this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
     this.WHZones =  response["WHZones"];
    }

    this.parent.loading = false;
   });
 }

 AddUpdateWarehouse(warehouse:any){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Warehouse:warehouse
  };

  this.parent.loading = true;

  this.service.AddUpdateWarehouse(request).subscribe(response => {

    if(response["Status"] != 1){
     this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      this.Warehouse = response["Warehouse"];
      this.NewWarehouse = {};
    }

    this.parent.loading = false;
    this.showAddNewWarehouse = false;
   });
 }

 DeleteWarehouse(){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    WarehouseID:this.Warehouse.ID
  };

  this.service.DeleteWarehouse(request).subscribe(response => {

    if(response["Status"] != 1){
     this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
     this.Warehouses = [];
     this.Warehouse = null;
    }
   });
 }

 AddUpdateWHZone(zone:any){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    WHZone:zone
  };

  this.parent.loading = true;

  this.service.AddUpdateWHZone(request).subscribe(response => {

    if(response["Status"] != 1){
     this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");

      if(zone.ID == 0){
        this.WHZones.push(response["WHZone"]);
      }
      this.NewWHZone = {};
    }

    this.parent.loading = false;
    this.showAddNewWHZone = false;
   });
 }

 DeleteWHZone(){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    ID:this.NewWHZone.ID
  };

  this.parent.loading = true;

  this.service.DeleteWHZone(request).subscribe(response => {

    if(response["Status"] != 1){
     this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.WHZones = this.WHZones.filter(x => x.ID != this.NewWHZone.ID);
      this.NewWHZone = {};
    }

    this.parent.loading = false;
   });
 }

 GetPartnersFiltered(){
  var request = {
    SearchTerm:this.PartnersFilter.SearchTerm,
    CountryID:this.PartnersFilter.Country?.ID,
    PageIndex:this.PartnersFilter.Pager.PageIndex,
    PageSize:this.PartnersFilter.Pager?.PageSize,
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    CompanyID:this.PartnersFilter.Company?.ID
  };

  this.parent.loading = true;

  this.service.GetPartnersFiltered(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
     this.Partners = response["Partners"];
     this.PartnersFilter.Pager.TotalCount = response["Count"];
    }
 
    this.parent.loading = false;
  });
}

ShowNewProfitSettings:boolean = false;
ProfitSettings:{[k: string]: any} = {};
ShowDeleteProfitMessage:boolean = false;

ImportConfigurations:any[];
BrandSearchTerm:string;
ConfigurationTerm:string;

OpenNewProfitSettings(){
  this.GetBrandsFiltered("", 1);

  this.ProfitSettings = {
    ID:0,
    PartnerID:null,
    PartnerName:null,
    DiscountGroup:null,
    ImportConfiguration:null,
    Brand:this.Brand,
    Percentage:null,
    PercentageImpact:this.ProfitSettingsPercentageImpacts[0],
    ExtraAddedValue:null,
    ExtraAddedPercentageValue:null,
  };

  this.PartnerSearchTerm = null;
  this.ConfigurationTerm = null;
  this.BrandSearchTerm = this.Brand?.Name;

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
  };
  
  this.parent.loading = true;
  
  this.service.CheckUserProfitRights(request).subscribe(response => {
  
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.ShowNewProfitSettings = true;
    }
  
    this.parent.loading = false;
   });
}

GetImportConfigurations(){

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    SearchTerm:this.ConfigurationTerm
  };
  
  this.parent.loading = true;
  
  this.managementService.GetImportConfigurations(request).subscribe(response => {
  
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.ImportConfigurations = response["ImportConfigurations"];
    }
  
    this.parent.loading = false;
   });
  }

InitializeImportConfigurations(){
    if(this.ImportConfigurations == null || this.ImportConfigurations.length == 0){
      this.GetImportConfigurations();
    }
}

SelectConfiguration(c:any){
    this.ProfitSettings.ImportConfiguration = c;
    this.ConfigurationTerm = c.Name;
    this.GetImportConfigurationDetails(c);
    this.ProfitSettings.DiscountGroup = null;
}

GetImportConfigurationDetails(c:any){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    ID:c.ID
  };

  this.parent.loading = true;
  this.managementService.GetImportConfigurationDetails(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.ProfitSettings.ImportConfiguration = response["Configuration"];
    }
 
    this.parent.loading = false;
  });
}

PartnerProfitSettings:any[];
PartnerSearchTerm:string

GetPartnerProfitSettings(){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    BrandID:this.Brand?.ID
  };
  
  this.parent.loading = true;
  
  this.service.GetPartnerProfitSettings(request).subscribe(response => {
  
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.PartnerProfitSettings = response["PartnerProfitSettings"];
    }
  
    this.parent.loading = false;
   });
}

AddUpdatePartnerProfitSettings(){

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    ProfitSettings:this.ProfitSettings,
  };
  
  this.parent.loading = true;
  
  this.service.AddUpdatePartnerProfitSettings(request).subscribe(response => {
  
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){

      var ps = response["ProfitSettings"];
      
      const index = this.PartnerProfitSettings.findIndex(x => x.ID === ps.ID);

      if (index !== -1) {
        this.PartnerProfitSettings[index] = ps;
      }
      else{
        this.PartnerProfitSettings.push(ps);
      }
    }
  
    this.parent.loading = false;
   });
}

EditProfitSettings(ps:any){

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
  };
  
  this.parent.loading = true;
  
  this.service.CheckUserProfitRights(request).subscribe(response => {
  
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.OpenProfitSettings(ps);
    }
  
    this.parent.loading = false;
   });
}

OpenProfitSettings(ps:any){
  this.BrandFilter.Pager.PageIndex = 1;
  this.BrandFilter.SearchTerm = "";
 
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Filter:this.BrandFilter
    };

    this.managementService.GetBrandsFiltered(request).subscribe(response => {

      if(response["Status"] != 1){
       this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
       this.Brands = response["Brands"];
       this.ProfitSettings = JSON.parse(JSON.stringify(ps));
       this.ConfigurationTerm = this.ProfitSettings.ImportConfiguration?.Name;
       this.BrandSearchTerm = this.ProfitSettings.Brand?.Name;
       this.PartnerSearchTerm = this.ProfitSettings.PartnerName;

       if(this.ProfitSettings.ImportConfiguration != null){
        this.GetImportConfigurationDetails(this.ProfitSettings.ImportConfiguration);
       }
      }
     });

  this.ShowNewProfitSettings = true;
}

CopyProfitSettingsUI(ps:any){
  this.CopyProfitSettings(ps);
}

CopyProfitSettings(ps:any){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
  };
  
  this.parent.loading = true;
  
  this.service.CheckUserProfitRights(request).subscribe(response => {
  
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.OpenProfitSettingsCopy(ps);
    }
  
    this.parent.loading = false;
   });
}

OpenProfitSettingsCopy(ps:any){
  this.BrandFilter.Pager.PageIndex = 1;
  this.BrandFilter.SearchTerm = "";
 
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Filter:this.BrandFilter
    };

    this.managementService.GetBrandsFiltered(request).subscribe(response => {

      if(response["Status"] != 1){
       this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
       this.Brands = response["Brands"];
       this.ProfitSettings = JSON.parse(JSON.stringify(ps));
       this.ConfigurationTerm = this.ProfitSettings.ImportConfiguration?.Name;
       this.BrandSearchTerm = this.ProfitSettings.Brand?.Name;
       this.PartnerSearchTerm = this.ProfitSettings.PartnerName;

       if(this.ProfitSettings.ImportConfiguration != null){
        this.GetImportConfigurationDetails(this.ProfitSettings.ImportConfiguration);
       }

       this.ProfitSettings.ID = 0;
       this.ProfitSettings.IsCopy = true;
      }
     });

  this.ShowNewProfitSettings = true;
}

DeleteProfitSettings(){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    ProfitSettings:this.ProfitSettings
  };
  
  this.parent.loading = true;
  
  this.service.DeleteProfitSettings(request).subscribe(response => {
  
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      this.PartnerProfitSettings = this.PartnerProfitSettings.filter(x => x.ID != this.ProfitSettings.ID);
      this.ProfitSettings = null;
      this.ProfitSettings = {};
    }
  
    this.ShowDeleteProfitMessage = false;
    this.ShowNewProfitSettings = false;
    this.parent.loading = false;
   });
}

ShowProfitFilter:boolean;

OpenProfitFilter(){
  this.ShowProfitFilter = !this.ShowProfitFilter;
}

}
